import { t } from "@lingui/macro";
import { UiTextFieldSearch } from "@smp/ui";
import { ChangeEvent } from "react";

import { useContextPolotnoTemplates } from "../../../../context";
import { useStyles } from "./search_bar.css";

export const SearchBar = () => {
  const classes = useStyles();
  const {
    state: { searchString },
  } = useContextPolotnoTemplates();

  const {
    actions: { changeSearchString },
  } = useContextPolotnoTemplates();

  const handleChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    changeSearchString(e.target.value);
  };

  return (
    <UiTextFieldSearch
      fullWidth
      variant="outlined"
      className={classes.input}
      label={t`Search template`}
      value={searchString}
      onChange={handleChange}
      debounce={500}
    />
  );
};
